module.exports = "<div *ngIf=\"person\">\n  <strong>{{person.nick}}</strong> - <span class=\"text-secondary small\">{{person.email}}</span>\n</div>"